export default function initNav(): void {
    const $navContainer = document.querySelectorAll<HTMLElement>('.js-main-header');

    $navContainer.forEach($container => {
        new Nav($container);
    });
}

class Nav {
    $body: HTMLElement | null | undefined;
    $el: HTMLElement | null | undefined;
    navBreakpoint: number;
    overlayDiv: HTMLDivElement | null = null;

    constructor($el: HTMLElement | null) {
        this.$body = document.querySelector('body');
        this.$el = $el;
        this.navBreakpoint = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-nav'));
        this.createOverlay();
        window.addEventListener('resize', this.onWindowResize.bind(this));
        this.onWindowResize();
        this.toggleMenu();
        this.toggleShadow();
    }

    createOverlay(): void {
        if (this.$body) {
            this.overlayDiv = document.createElement("div");
            this.overlayDiv.classList.add("overlay-nav");
            this.$body.appendChild(this.overlayDiv);
        }
    }


    onWindowResize(): void {
        if (window.innerWidth < this.navBreakpoint) {
            this.$el?.classList.add('header-mobile');

        } else if (window.innerWidth > this.navBreakpoint) {
            this.$el?.classList.remove('header-mobile');
            this.$el?.classList.remove('main-header--active');
        }
    }

    toggleMenu(): void {
        const $burgerBtn = this.$el?.querySelector('.js-burger-btn');


        $burgerBtn?.addEventListener('click', () => {
            this.$el?.classList.toggle('main-header--active');
            this.$body?.classList.toggle('prevent-scroll');

            if (this.$el?.classList.contains('submenu-active')) {
                this.$el?.classList.remove('submenu-active');
            }


            if (this.$el?.classList.contains('main-header--active')) {
                const $elementWithSubmenus = this.$el.querySelectorAll('.nav-submenu');

                $elementWithSubmenus.forEach(el => {
                    el.addEventListener('click', () => {
                        this.$el?.classList.toggle('submenu-active');
                        el.classList.toggle('submenu-is-active')
                    })
                })
            }
        });
    }

    toggleShadow(): void {
        const $navSubMenu = [...this.$el?.querySelectorAll(".nav-element") || []].filter(el => el.querySelector('.nav-submenu'));

        $navSubMenu?.forEach(subMenu => {
            subMenu.addEventListener('mouseenter', () => {
                if (window.innerWidth >= this.navBreakpoint) {
                    this.overlayDiv?.classList.add('active');
                }
            });

            subMenu.addEventListener('mouseleave', () => {
                this.overlayDiv?.classList.remove('active');
            });
        });
    }
}
